import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MenuItem, useLink } from '@shapeable/ui';
import { DcoDoingsIconGlyph } from '../icons/dco-doings-icon';

const cls = classNames('user-menu-items');

// -------- Types -------->

// -------- Props -------->

export type LoggedInUserMenuItemsProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const LoggedInUserMenuItemsDefaultProps: Omit<LoggedInUserMenuItemsProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MenuItem)<ContainerProps>`${ContainerStyles}`,
};

export const LoggedInUserMenuItems: Shapeable.FC<LoggedInUserMenuItemsProps> = (props) => {
  const { 
    className, children, entity, 
  } = props;

  const { navigate } = useLink();
  
  return (
    <My.Container 
      className={cls.name(className)}
      label='My Hub'
      onClick={() => navigate(`https://hub.doingco.org`)}
      iconComponent={DcoDoingsIconGlyph}
      >
    {children}
    </My.Container>
  )
};

LoggedInUserMenuItems.cls = cls;